import loadScript from 'load-script';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { TableStencil } from 'app/components/shared/Table';

import LocationItemInfo from 'app/components/locations/LocationsPage/LocationItemInfo';
import {
  selectLocations,
  selectPreferredLocations,
  selectNearPoint,
  selectDefaultMapState,
  selectCountry
} from 'app/selectors/locations/LocationsSearchSelector';
import { selectLocalization } from 'app/selectors/LocalizationSelector';

import './LocationsMap.scss';

const iconUrls = {
  current:
    'data:image/svg+xml;charset=UTF-8;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCAzMCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjYwNDQgMjMuNzM0NkMyOC40MjI2IDIxLjMwNzggMjkuNSAxOC4yOTE0IDI5LjUgMTUuMDI0NEMyOS41IDcuMDAzNjEgMjMuMDA4OSAwLjUgMTUgMC41QzYuOTkxMDUgMC41IDAuNSA3LjAwMzYxIDAuNSAxNS4wMjQ0QzAuNSAxOC4yOTA3IDEuNTc2OTUgMjEuMzA2NSAzLjM5NDQ4IDIzLjczM0M1LjA3MzM2IDI2LjExNTUgNy41ODE2NCAyOS43NDUzIDkuNjY5NTMgMzMuMjY1N0MxMC43MTQ2IDM1LjAyNzkgMTEuNjQ4NyAzNi43NTMxIDEyLjMxOTkgMzguMjc0NEMxMi45OTg5IDM5LjgxMzUgMTMuMzc5OSA0MS4wODEzIDEzLjM3OTkgNDEuOTUxMkwxMy4zOCA0NS44NzgxQzEzLjM4IDQ2LjE0NDkgMTMuNDU1OCA0Ni41MzQxIDEzLjY5OCA0Ni44NzExQzEzLjk1ODUgNDcuMjMzNiAxNC4zODg3IDQ3LjUgMTUgNDcuNUMxNS42MTEzIDQ3LjUgMTYuMDQxNSA0Ny4yMzM2IDE2LjMwMiA0Ni44NzExQzE2LjU0NDIgNDYuNTM0MSAxNi42MiA0Ni4xNDQ5IDE2LjYyIDQ1Ljg3OFY0MS45NTEyQzE2LjYyIDQxLjA4MTMgMTcuMDAxIDM5LjgxMzcgMTcuNjc5OCAzOC4yNzQ5QzE4LjM1MDkgMzYuNzUzNyAxOS4yODQ4IDM1LjAyODggMjAuMzI5NyAzMy4yNjY4QzIyLjQxNzMgMjkuNzQ2OSAyNC45MjUzIDI2LjExNzMgMjYuNjA0NCAyMy43MzQ2WiIgZmlsbD0iIzUwODZFQyIgc3Ryb2tlPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjE1IiByPSI1IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=',
  default:
    'data:image/svg+xml;charset=UTF-8;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCAzMCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjYwNDQgMjMuNzM0NkMyOC40MjI2IDIxLjMwNzggMjkuNSAxOC4yOTE0IDI5LjUgMTUuMDI0NEMyOS41IDcuMDAzNjEgMjMuMDA4OSAwLjUgMTUgMC41QzYuOTkxMDUgMC41IDAuNSA3LjAwMzYxIDAuNSAxNS4wMjQ0QzAuNSAxOC4yOTA3IDEuNTc2OTUgMjEuMzA2NSAzLjM5NDQ4IDIzLjczM0M1LjA3MzM2IDI2LjExNTUgNy41ODE2NCAyOS43NDUzIDkuNjY5NTMgMzMuMjY1N0MxMC43MTQ2IDM1LjAyNzkgMTEuNjQ4NyAzNi43NTMxIDEyLjMxOTkgMzguMjc0NEMxMi45OTg5IDM5LjgxMzUgMTMuMzc5OSA0MS4wODEzIDEzLjM3OTkgNDEuOTUxMkwxMy4zOCA0NS44NzgxQzEzLjM4IDQ2LjE0NDkgMTMuNDU1OCA0Ni41MzQxIDEzLjY5OCA0Ni44NzExQzEzLjk1ODUgNDcuMjMzNiAxNC4zODg3IDQ3LjUgMTUgNDcuNUMxNS42MTEzIDQ3LjUgMTYuMDQxNSA0Ny4yMzM2IDE2LjMwMiA0Ni44NzExQzE2LjU0NDIgNDYuNTM0MSAxNi42MiA0Ni4xNDQ5IDE2LjYyIDQ1Ljg3OFY0MS45NTEyQzE2LjYyIDQxLjA4MTMgMTcuMDAxIDM5LjgxMzcgMTcuNjc5OCAzOC4yNzQ5QzE4LjM1MDkgMzYuNzUzNyAxOS4yODQ4IDM1LjAyODggMjAuMzI5NyAzMy4yNjY4QzIyLjQxNzMgMjkuNzQ2OSAyNC45MjUzIDI2LjExNzMgMjYuNjA0NCAyMy43MzQ2WiIgZmlsbD0iI0Q5NTA0MCIgc3Ryb2tlPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjE1IiByPSI1IiBmaWxsPSIjODExNDExIi8+Cjwvc3ZnPg==',
  numbered:
    'data:image/svg+xml;charset=UTF-8;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCAzMCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjYwNDQgMjMuNzM0NkMyOC40MjI2IDIxLjMwNzggMjkuNSAxOC4yOTE0IDI5LjUgMTUuMDI0NEMyOS41IDcuMDAzNjEgMjMuMDA4OSAwLjUgMTUgMC41QzYuOTkxMDUgMC41IDAuNSA3LjAwMzYxIDAuNSAxNS4wMjQ0QzAuNSAxOC4yOTA3IDEuNTc2OTUgMjEuMzA2NSAzLjM5NDQ4IDIzLjczM0M1LjA3MzM2IDI2LjExNTUgNy41ODE2NCAyOS43NDUzIDkuNjY5NTMgMzMuMjY1N0MxMC43MTQ2IDM1LjAyNzkgMTEuNjQ4NyAzNi43NTMxIDEyLjMxOTkgMzguMjc0NEMxMi45OTg5IDM5LjgxMzUgMTMuMzc5OSA0MS4wODEzIDEzLjM3OTkgNDEuOTUxMkwxMy4zOCA0NS44NzgxQzEzLjM4IDQ2LjE0NDkgMTMuNDU1OCA0Ni41MzQxIDEzLjY5OCA0Ni44NzExQzEzLjk1ODUgNDcuMjMzNiAxNC4zODg3IDQ3LjUgMTUgNDcuNUMxNS42MTEzIDQ3LjUgMTYuMDQxNSA0Ny4yMzM2IDE2LjMwMiA0Ni44NzExQzE2LjU0NDIgNDYuNTM0MSAxNi42MiA0Ni4xNDQ5IDE2LjYyIDQ1Ljg3OFY0MS45NTEyQzE2LjYyIDQxLjA4MTMgMTcuMDAxIDM5LjgxMzcgMTcuNjc5OCAzOC4yNzQ5QzE4LjM1MDkgMzYuNzUzNyAxOS4yODQ4IDM1LjAyODggMjAuMzI5NyAzMy4yNjY4QzIyLjQxNzMgMjkuNzQ2OSAyNC45MjUzIDI2LjExNzMgMjYuNjA0NCAyMy43MzQ2WiIgZmlsbD0iI0Q5NTA0MCIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4=',
  preferred:
    'data:image/svg+xml;charset=UTF-8;base64,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'
};

const ZOOM = 14;
const MAXZOOM = 18;

export default function LocationsMap() {
  const mapRef = useRef();
  const apiKey = useSelector(state => state.getIn(['locations', 'locationsSearch', 'googleMapsApiKey']));
  const isFetching = useSelector(state => state.getIn(['locations', 'locationsSearch', 'isFetching'], false));
  const locations = useSelector(selectLocations);
  const preferredLocations = useSelector(selectPreferredLocations);
  const nearPoint = useSelector(selectNearPoint);
  const defaultMapState = useSelector(selectDefaultMapState);
  const country = useSelector(selectCountry);
  const locale = useSelector(selectLocalization).currentLanguage;

  const locationIdToIsPreferred = preferredLocations.reduce((acc, preferredLocation) => {
    acc[preferredLocation.get('id')] = true;
    return acc;
  }, {});

  useEffect(() => {
    let instance;
    let mapBounds;

    function loadMap() {
      if (window.google?.maps) {
        const maps = window.google.maps;

        if (mapRef.current && !isFetching) {
          const options = {
            draggable: true,
            mapTypeId: maps.MapTypeId?.ROADMAP,
            scrollwheel: false,
            zoom: ZOOM,
            maxZoom: MAXZOOM
          };

          mapBounds = new maps.LatLngBounds();

          if (locations.size) {
            locations.forEach(location => {
              const lat = location.getIn(['mapLocation', 'centrePoint', 'lat']);
              const lng = location.getIn(['mapLocation', 'centrePoint', 'lng']);
              if (!(lat && lng)) {
                return;
              }

              mapBounds.extend(new maps.LatLng(lat, lng));
            });
          }

          if (nearPoint) {
            const bounds = nearPoint.get('bounds');
            if (bounds) {
              const southWest = new maps.LatLng(bounds.get('southwest').get('lat'), bounds.get('southwest').get('lng'));
              const northEast = new maps.LatLng(bounds.get('northeast').get('lat'), bounds.get('northeast').get('lng'));
              mapBounds = new maps.LatLngBounds(southWest, northEast);
            } else {
              mapBounds.extend(new maps.LatLng(nearPoint.get('lat'), nearPoint.get('lng')));
            }
          }

          options.center = mapBounds.getCenter();

          if (!locations.size) {
            options.center = new maps.LatLng(
              defaultMapState?.getIn(['centre', 'lat']),
              defaultMapState?.getIn(['centre', 'lng'])
            );
            options.zoom = defaultMapState?.get('zoom') || ZOOM;
          }

          instance = new maps.Map(mapRef.current, options);
          if (instance && locations.size) {
            instance.setCenter(options.center);
            instance.setZoom(ZOOM);
          }

          if (locations.size) {
            instance.fitBounds(mapBounds);
            const infoWindow = new maps.InfoWindow();

            locations.forEach((location, index) => {
              const lat = location.getIn(['mapLocation', 'centrePoint', 'lat']);
              const lng = location.getIn(['mapLocation', 'centrePoint', 'lng']);
              if (!(lat && lng)) {
                return;
              }

              const isPreferredLocation = locationIdToIsPreferred[location.get('id')];

              let iconUrl = iconUrls.default;
              if (nearPoint) {
                iconUrl = iconUrls.numbered;
              } else if (isPreferredLocation) {
                iconUrl = iconUrls.preferred;
              }

              const marker = new maps.Marker({
                label:
                  iconUrl === iconUrls.numbered
                    ? {
                        className: 'numbered-marker-label',
                        color: 'white',
                        text: String(index + 1)
                      }
                    : null,
                icon: iconUrl,
                map: instance,
                position: new maps.LatLng(lat, lng),
                title: location.get('name')
              });

              marker.addListener('click', () => {
                const templateId = `LocationTemplate_${location.get('id')}`;

                infoWindow.setContent(document.getElementById(templateId)?.children[0]?.outerHTML || '');
                infoWindow.open({
                  anchor: marker,
                  map: instance,
                  maxWidth: 240
                });
              });
            });
          }

          if (nearPoint) {
            // eslint-disable-next-line no-new
            new maps.Marker({
              cursor: 'grab',
              icon: iconUrls.current,
              map: instance,
              position: new maps.LatLng(nearPoint.get('lat'), nearPoint.get('lng'))
            });
          }
        }
      } else {
        // BCAdmin settings have dependeny on Events release 3.12.0, adding the fallback key
        const mapsApiKey = apiKey ?? 'AIzaSyBxJQzKiIr5VZbtytOSoJwitV2WPGGAAKg';
        const regionParam = country ? `&region=${country}` : '';
        const languageParam = locale ? `&language=${locale}` : '';
        const scriptSrc = `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&libraries=places${regionParam}${languageParam}`;
        loadScript(scriptSrc, loadMap);
      }
    }

    loadMap();

    return () => {
      if (instance) {
        window.google?.maps.event.clearInstanceListeners(instance);
      }
    };
  }, [locationIdToIsPreferred, locations, nearPoint, mapRef, isFetching, defaultMapState, apiKey, country, locale]);

  return (
    <div className="cp-locations-map">
      <div className="locations-map">
        <div className="map-container" ref={mapRef}>
          <TableStencil />
        </div>
      </div>
      {locations.map(location => (
        <script id={`LocationTemplate_${location.get('id')}`} key={location.get('id')} type="text/template">
          <div className="location-info">
            <LocationItemInfo
              isInfoWindow
              location={location}
              preferred={locationIdToIsPreferred[location.get('id')]}
            />
          </div>
        </script>
      ))}
    </div>
  );
}
